const data = {
  title: 'Serving England, Wales and Scotland',
  subtitle:
    'We can arrange a cremation even in the remotest places. Just give our friendly team a call if you’re unsure whether we serve your area.',
  image: 'funerals/landing/england-wales-and-scotland',
  cta: 'Call us today',
}

export default data
